import React, { useState, useRef } from 'react';
import { Play, Pause, Volume2, VolumeX, Maximize } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const VideoTour = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);
  const { t } = useLanguage();

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) { videoRef.current.pause(); } else { videoRef.current.play(); }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const toggleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) videoRef.current.requestFullscreen();
      else if (videoRef.current.webkitRequestFullscreen) videoRef.current.webkitRequestFullscreen();
    }
  };

  return (
    <section className="video-tour-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="section-badge">{t('videoTour.badge')}</div>
          <h2 className="section-title">{t('videoTour.title')}</h2>
          <p className="section-description">{t('videoTour.description')}</p>
        </div>

        <div className="video-container">
          <div className="video-wrapper">
            <video
              ref={videoRef}
              className="video-player"
              muted={isMuted}
              loop
              playsInline
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            >
              <source src="https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/faufoc7g_villa%20in%20pietra%20v4.MP4" type="video/mp4" />
            </video>

            <div className="video-controls-overlay">
              <button className="video-play-button" onClick={togglePlay} aria-label={isPlaying ? 'Pause' : 'Play'}>
                {isPlaying ? <Pause className="h-16 w-16" /> : <Play className="h-16 w-16" />}
              </button>
            </div>

            <div className="video-controls-bottom">
              <button className="video-control-btn" onClick={toggleMute} aria-label={isMuted ? 'Unmute' : 'Mute'}>
                {isMuted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
              </button>
              <button className="video-control-btn" onClick={toggleFullscreen} aria-label="Fullscreen">
                <Maximize className="h-5 w-5" />
              </button>
            </div>
          </div>

          <div className="video-features">
            <div className="video-feature-item">
              <span className="feature-icon">🏊</span>
              <span>{t('videoTour.pool')}</span>
            </div>
            <div className="video-feature-item">
              <span className="feature-icon">🏛️</span>
              <span>{t('videoTour.antiques')}</span>
            </div>
            <div className="video-feature-item">
              <span className="feature-icon">🌳</span>
              <span>{t('videoTour.estate')}</span>
            </div>
            <div className="video-feature-item">
              <span className="feature-icon">🛏️</span>
              <span>{t('videoTour.bedrooms')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
